// Beach Room Configuration

import { Room } from '../config/room-types.js';
import { STANDARD_BOUNDARIES } from '../config/room-constants.js';

export const dockRoom: Room = {
  name: 'Dock',
  background: '/media/club-penguin/dock.webp',
  spawn: { x: 341, y: 338 },

  colliders: [...STANDARD_BOUNDARIES],

  hotspots: [
    {
      id: 'dock-to-beach',
      action: 'goto',
      target: 'beach',
      spawn: { x: 699, y: 189 },
      x: 24,
      y: 241,
      w: 91,
      h: 169,
    },
    {
      id: 'dock-to-town',
      action: 'goto',
      target: 'town',
      spawn: { x: 147, y: 340 },
      x: 853,
      y: 150,
      w: 78,
      h: 107,
    },

    {
      id: 'dock-to-ski-village',
      action: 'goto',
      target: 'ski-village',
      spawn: { x: 253, y: 455 },
      x: 132,
      y: 119,
      w: 141,
      h: 49,
    },
  ],
};
